import { useEffect, useState } from "react";

function UpdateAppComponent({ latestVersion, playStoreUrl,userDenied }) {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const versionCode = parseInt(queryParams.get("version_code") || "0");

    

    if (versionCode < latestVersion && versionCode) {
      setShowUpdate(true);
    }
  }, [latestVersion]);

  if (!showUpdate) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <h2>Update Required</h2>
        <p>Your app version is outdated. Please update to continue.</p>

        <button
          onClick={() => {
            window.location.href = playStoreUrl;
          }}
          style={styles.button}
        >
          Update Now
        </button>&nbsp;&nbsp;&nbsp;&nbsp;
         <button
          onClick={() => {
            userDenied(false);
          }}
          style={styles.buttonLtr}
        >
          Later
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popup: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    textAlign: "center",
    width: "300px",
  },
  button: {
    marginTop: "15px",
    padding: "10px 15px",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
  },
  buttonLtr: {
    marginTop: "15px",
    padding: "10px 15px",
    backgroundColor: "#e1ece4",
    color: "#0f0b0b",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
  },
};

export default UpdateAppComponent;